import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import MediaIndicator from '@wix/da-ds/pkg/thumbs/MediaIndicator';
import Stats from '../../Stats';
import DeviationLink from '../../Duperbrowse/DeviationLink';
import DeviationThumbIndicators, { AllowedIndicators } from '../../DeviationViews/Thumb/legos/DeviationThumbIndicators';
import { getVideoDuration, isVideoOrGif } from '../../utils/deviations';
import { formatDollars } from '../../utils/formatting';
import { isBoostedDeviation, isMultiImageDeviation } from '../../DeviationViews/_helpers';
import PriceWithPoints from '../_partials/PriceWithPoints';
import ShopCardDumb from '../_partials/ShopCardDumb';
import { getDeviationPrice } from '../helpers';
import s from './DeviationShopCard.scss';
const DeviationShopCard = ({ deviation, width, withAuthorDetails, allowedIndicators = AllowedIndicators.All, withStats, withPremiumDownloadCount, withDreamupLabel, withDescriptionBlock, detailsRightSlot, belowCoverImageRightSlot, footerSlot, noCentsOnPrice, overrideHref, withOwnerDetails, extraBiData })=>{
    var _deviation_adoptable, _deviation_author;
    const { t } = useTranslation();
    const { dollarsPrice, pointsPrice } = getDeviationPrice(deviation);
    const isBoosted = isBoostedDeviation(deviation);
    const owner = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.owner;
    const formattedDollarsPrice = noCentsOnPrice ? `$${parseInt(dollarsPrice)}` : formatDollars(dollarsPrice);
    var _owner_username;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(DeviationLink, {
        className: s['link'],
        deviation: deviation,
        overrideHref: overrideHref,
        extraBiData: extraBiData,
        canLinkToStash: true,
        "aria-label": t('shop.thumb.a11y.shopLink', {
            username: (_owner_username = owner === null || owner === void 0 ? void 0 : owner.username) !== null && _owner_username !== void 0 ? _owner_username : (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username,
            deviationName: deviation.title,
            dollarsPrice: formattedDollarsPrice,
            count: pointsPrice
        })
    }), /*#__PURE__*/ React.createElement(ShopCardDumb, {
        // Hiding the rest from screenreaders because the link's aria-label has the necessary info
        "aria-hidden": "true",
        width: width,
        coverImage: deviation,
        title: deviation.title,
        isBoosted: isBoosted,
        withAuthorDetails: withAuthorDetails,
        author: deviation.author,
        withDescriptionBlock: withDescriptionBlock,
        description: deviation.textContent,
        withOwnerDetails: withOwnerDetails,
        owner: owner,
        indicatorsSlot: /*#__PURE__*/ React.createElement(React.Fragment, null, allowedIndicators !== AllowedIndicators.None && /*#__PURE__*/ React.createElement(DeviationThumbIndicators, {
            className: s['indicators'],
            deviation: deviation,
            allowedIndicators: allowedIndicators
        }), /*#__PURE__*/ React.createElement(MediaIndicator, {
            className: s['media-indicator'],
            type: isVideoOrGif(deviation),
            duration: getVideoDuration(deviation),
            isMultiImage: isMultiImageDeviation(deviation)
        })),
        belowCoverImageSlot: withStats && /*#__PURE__*/ React.createElement(Flex, {
            justifyContent: "space-between"
        }, /*#__PURE__*/ React.createElement(Stats, {
            deviation: deviation,
            withViewCount: false,
            withBadges: false,
            withCommentControl: false,
            withSubscriberCount: false,
            withPremiumDownloadCount: withPremiumDownloadCount,
            withUserList: false,
            withDaProtectIndicator: false,
            withNoAiIndicator: false,
            onlyNumbers: true
        }), belowCoverImageRightSlot),
        detailsRightSlot: detailsRightSlot || /*#__PURE__*/ React.createElement(PriceWithPoints, {
            formattedDollarsPrice: formattedDollarsPrice,
            pointsPrice: pointsPrice
        }),
        footerSlot: footerSlot
    }));
};
DeviationShopCard.displayName = 'DeviationShopCard';
export default DeviationShopCard;

//# sourceMappingURL=DeviationShopCard.js.map